module.exports = __webpack_public_path__ + "img/lrc-form@2x.5906a287.png";